import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useSmartActionsStore } from '@/modules/viewer/store/useSmartActionsStore';
import { useToDoStore } from '@/modules/viewer/store/useToDoStore';

// vue3-tabs-component renders the tab's `name` via innerHTML, so a real badge
// element can be embedded in the label string even though neither our Tab.vue
// wrapper nor the library exposes a slot for it. Callers style `badgeClass`
// with :deep() since v-html'd content isn't scoped.
export const useToDo = ({ badgeClass = '' }: { badgeClass?: string } = {}) => {
  const smartActionsStore = useSmartActionsStore();
  const { count } = storeToRefs(useToDoStore());

  const isToDoAvailable = computed(() => {
    const { actionType, smartActionsWithToDos } = smartActionsStore;
    return !!actionType && smartActionsWithToDos.includes(actionType);
  });

  const toDoTabLabel = computed(() => {
    if (!count.value) {
      return 'To-Do';
    }
    return `To-Do <span class="${badgeClass}">${count.value}</span>`;
  });

  return { isToDoAvailable, toDoTabLabel };
};
